
import { Component, Vue, Prop } from "vue-property-decorator";
import { formatUpyunUrl } from "@/utils";
@Component({
  components: {}
})
export default class Business extends Vue {
  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/798bf57dd811d25cd3be074bcd86ca20.png";
  pic2 = "/img/b72d2f0801b1717b4ab6bb4f505ebc9a.png";
  pic3 = "/img/e10e6371071e3af169368010b00b32f9.png";
  pic4 = "/img/db47f30b14a9cd5b0501381c739b2c2e.png";
  pic5 = "/img/dcd2ef5bb566a3857d66e3b985e1a30d.png";
  pic6 = "/img/3e49c22e8a818915dae656c4ef5f7f86.png";
  getMore(index: any) {
    switch (index) {
      case 0: // 光华商学院
        this.$router.push("/business-school");
        break;
      case 1: // 科研院
        this.$router.push("/research-institute");
        break;
      case 2: // 数字化
        this.$router.push("/digital-running-companion");
        break;
      case 3: // 内训
        this.$router.push("/internal-training");
        break;
      case 4: // 大增长营
        this.$router.push("/growth-camp");
        break;
      case 5: // 共创会
        this.$router.push("/academy");
        break;
      case 6: // 咨询陪跑
        this.$router.push("/accompany");
        break;
      default:
        break;
    }
  }
}
